import request from '../request';

/**
 * 获取里程碑计划项目列表
 * @param invoiceToken 里程碑计划开票人员令牌
 */
export const getMilestonePlanProjectsApi = async (invoiceToken: string): Promise<API.MilestonePlan.Project[]> => {
    return await request.get(`/workbenchApi/projects/invoice-milestone-projects/${invoiceToken}`);
};
export const createMilestonePlanPlmProjectApi = async (standardMilestoneDateProjectID: number): Promise<API.ListData<API.MilestonePlan.Project>> => {
    return await request.post(`/workbenchApi/projects/invoice-milestone-projects/projects`, {
        standardMilestoneDateProjectID: standardMilestoneDateProjectID
    });
};
export const checkMilestonePlanPlmProjectCreateStatusApi = async (standardMilestoneDateProjectID: number): Promise<{ status: string, projectID: number }>  => {
    return await request.get(`/workbenchApi/projects/invoice-milestone-projects/queue`, {
        params: {
            standardMilestoneDateProjectID: standardMilestoneDateProjectID
        }
    });
};

export const getMilestonePlanWarnNodeApi = (invoiceToken: string): Promise<{ milestoneCode: string }> => {
    let url = `/workbenchApi/projects/invoice-milestone-projects/${invoiceToken}/info`
    return request.get(url);
}
// 获取项目外协交圈时间
export const getMilestoneCircleNodeApi = (projectID: number | string, plotID?: number): Promise<API.PROJECT.CircleMilestone>  => {
    let url = `/workbenchApi/projects/${projectID}/circle-completion?plotID=${plotID}`
    return request.get(url);
}
// 获取项目开票人员时间限制
export const getMilestoneInvoiceTimeLimitApi = (projectID: number | string): Promise<Record<string, string>> => {
    let url = `/workbenchApi/projects/${projectID}/kptime`
    return request.get(url);
}